import { render, staticRenderFns } from "./Article0004.vue?vue&type=template&id=4bbdc302&scoped=true&"
import script from "./Article0004.vue?vue&type=script&lang=js&"
export * from "./Article0004.vue?vue&type=script&lang=js&"
import style0 from "./Article0004.vue?vue&type=style&index=0&id=4bbdc302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbdc302",
  null
  
)

export default component.exports